import { fetchAuthSession } from 'aws-amplify/auth';

import { EnvironmentConfig, environmentService } from './environmentService';

const LOCAL_HOSTS = ['localhost', '127.0.0.1'];

/**
 * Local development mode: environment.json says "local" (written by
 * scripts/dev.sh) AND the page is served from this machine. Cognito is skipped
 * entirely. The hostname check keeps a misconfigured environment.json from
 * ever enabling this on the deployed site.
 */
export function isLocalAuth(config: EnvironmentConfig | null): boolean {
  return (
    config?.environment === 'local' &&
    LOCAL_HOSTS.includes(window.location.hostname)
  );
}

// Unsigned JWT ({ sub: 'local-dev', email: 'local@localhost',
// 'custom:clearanceLevel': '3' }), an admin, for the local ToolsAPI, whose
// middleware only decodes claims; API Gateway verifies the
// signature in production, where this token is never sent.
const LOCAL_ID_TOKEN =
  'eyJhbGciOiJub25lIn0.eyJzdWIiOiJsb2NhbC1kZXYiLCJlbWFpbCI6ImxvY2FsQGxvY2FsaG9zdCIsImN1c3RvbTpjbGVhcmFuY2VMZXZlbCI6IjMifQ.local';

/**
 * The ID token to send as the Bearer token on API requests.
 */
export async function getIdToken(): Promise<string | undefined> {
  if (isLocalAuth(await environmentService.getConfig())) {
    return LOCAL_ID_TOKEN;
  }
  const session = await fetchAuthSession();
  return session.tokens?.idToken?.toString();
}
